import { render } from "./LightboxTable.vue?vue&type=template&id=cf816fc8&scoped=true"
import script from "./LightboxTable.vue?vue&type=script&lang=js"
export * from "./LightboxTable.vue?vue&type=script&lang=js"

import "./LightboxTable.vue?vue&type=style&index=0&id=cf816fc8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf816fc8"]])

export default __exports__